import type { MaybeRef } from 'vue';

import type { RequestMeta } from '@/shared/api';

export const kubernetesKeys = {
  all: ['kubernetes'] as const,
  clusters: (params: MaybeRef<RequestMeta>) => [...kubernetesKeys.all, 'clusters', params] as const,
  cluster: (uuid: MaybeRef<string>) => [...kubernetesKeys.all, 'cluster', uuid] as const,
  dataForCreate: () => [...kubernetesKeys.all, 'data-for-create'] as const,
};
